import RecallPage from './RecallPage';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import { getRecallServices } from 'store/reducers/recall/selectors';
import {
  getVehicle,
  getParamRecallIds
} from 'store/reducers/appointment/selectors';
import {
  getCTABanner,
  hideBottomCTA
} from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => {
  return {
    vehicle: getVehicle(state),
    recallServices: getRecallServices(state),
    recallsSelected: getParamRecallIds(state),
    ctaBanner: getCTABanner(state),
    hideBottomCTA: hideBottomCTA(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ goTo, gtmUserEvent }, dispatch);

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(RecallPage);



// WEBPACK FOOTER //
// ./src/components/pages/RecallPage/RecallPageContainer.js